import { configureStore } from "@reduxjs/toolkit";

import retriveTenantInformationreducer from "../reducers/auth_tenant/retrieve_tenant_information_Slice";
import retrieveTenantUserInformationReducer from "../reducers/auth_tenant/retrieve_tenant_user_information_Slice";
import retrieveTenantsListReducer from "../reducers/auth_tenant/retrieve_tenants_list_Slice";
import adminCreateTenantReducer from "../reducers/auth_tenant/admin_create_tenant_Slice";
import retrieveProductTypesReducer from "../reducers/auth_tenant/retrieve_product_types_Slice";
import addProductTypeReducer from "../reducers/auth_tenant/add_product_type_Slice";
import retrieveProductsReducer from "../reducers/auth_tenant/retrieve_products_Slice";
import retrieveProductsTypesByStatusReducer from "../reducers/auth_tenant/retrieve_product_types_by_status_Slice";
import addProducteReducer from "../reducers/auth_tenant/add_product_Slice";
import retrieveWarehouseSitesReducer from "../reducers/auth_tenant/retrieve_warehouse_sites_Slice";
import addWarehouseSiteReducer from "../reducers/auth_tenant/add_warehouse_site_Slice";
import retrieveTenantAuditTrailsReducer from "../reducers/auth_tenant/retrieve_tenant_audit_trails_Slice";
import retrieveTenantProfilesListReducer from "../reducers/auth_tenant/retrieve_tenant_profiles_list_Slice";
import retrieveSpecificTenantSettingsReducer from "../reducers/auth_tenant/retrieve_specific_tenant_settings_Slice";
import updateTenantLogoReducer from "../reducers/auth_tenant/update_tenant_logo_Slice";
import retrieveProfileDetailsReducer from "../reducers/auth_tenant/retrieve_profile_details_Slice";
import retrieveTenantProfileRolesReducer from "../reducers/auth_tenant/retrieve_tenant_profile_roles_Slice";
import updateTenantProfileRoleReducer from "../reducers/auth_tenant/update_tenant_profile_role_Slice";
import retrieveSpecificTenantProductDetailsReducer from "../reducers/auth_tenant/retrieve_specific_tenant_product_details_Slice";
import retrieveAddStockDetailsReducer from "../reducers/auth_tenant/retreive_add_stock_details_Slice";
import authSignOutReducer from "../reducers/auth_tenant/auth_sign_out_Slice";
import addProductStockReducer from "../reducers/auth_tenant/add_product_stock_Slice";
import retreiveTenantSalesRepsReducer from "../reducers/auth_tenant/retrieve_tenant_sales_reps_Slice";
import retrieveBrandsListReducer from "../reducers/auth_tenant/retrieve_brands_list_Slice";
import addTenantSalesRepReducer from "../reducers/auth_tenant/add_tenant_sales_rep_Slice";
import retrieveSalesRepTenantPendingSubmissionsCartReducer from "../reducers/auth_tenant/retrieve_sales_rep_tenant_pending_submissions_cart_Slice";
import salesRepTenanrCreateOrderReducer from "../reducers/auth_tenant/sales_rep_tenant_create_order_Slice";
import updateTenantEmailCredentialsReducer from "../reducers/auth_tenant/update_tenant_email_credentials_Slice";
import addEmployeeToTenantReducer from "../reducers/auth_tenant/add_employee_to_tenant_Slice";
import retrieveTenantOrdersListReducer from "../reducers/auth_tenant/retrieve_tenant_orders_list_Slice";
import updateTenantSmsCredentialsReducer from "../reducers/auth_tenant/update_tenant_sms_credentials_Slice";
import retrieveSalesRepTenantOrderListReducer from "../reducers/auth_tenant/retrieve_sales_rep_tenant_order_list_Slice";
import retrieveSepecificSalesRepTenantOrderDetailsReducer from "../reducers/auth_tenant/retrieve_specific_sales_rep_tenant_order_details_Slice";
import updateTenantOrderStatusReducer from "../reducers/auth_tenant/update_tenant_order_status_Slice";
import addProductToExistingOrderReducer from "../reducers/auth_tenant/add_product_to_existing_order_Slice";
import createTenantOrderDispatchReducer from "../reducers/auth_tenant/create_tenant_order_dispatch_Slice";
import retrieveTenantDispatchDetailsReducer from "../reducers/auth_tenant/retrieve_tenant_dispatch_details_Slice";
import addProductsToDispatchAndCompleteDispatchReducer from "../reducers/auth_tenant/add_products_to_dispatch_and_complete_dispatch_Slice";
import salesRepConfirmDispatchDeliveryReducer from "../reducers/auth_tenant/sales_rep_confirm_dispatch_delivery_Slice";
import retrieveTenantGoodsReceivedListRefucer from "../reducers/auth_tenant/retrieve_tenants_goods_received_list_Slice";
import addTenantGoodsRecievedReducer from "../reducers/auth_tenant/add_tenant_goods_received_Slice";
import retrieveGoodsReceivedDetailsReducer from "../reducers/auth_tenant/retrieve_goods_received_details_Slice";
import addProductsToGoodsReceivedAndCompleteGoodsReceivedRedcuer from "../reducers/auth_tenant/add_products_to_goods_received_and_complete_goods_received_Slice";
import retrieveTenantDashboardDataReducer from "../reducers/auth_tenant/retrieve_tenant_dashboard_data_Slice";
import updateTenantProductImageReducer from "../reducers/auth_tenant/update_tenant_product_image_Slice";
import tenantBackDateOrderReducer from "../reducers/auth_tenant/tenant_back_date_order_Slice";
import tenantAddBackdatedOrderProductsReducer from "../reducers/auth_tenant/tenant_add_backdated_order_products_Slice";


// Stock Take
import retrieveTenantStockTakeListReducer from "../reducers/auth_tenant/retrieve_tenant_stock_take_list_Slice";
import retrieveTenantStockTakeStartinBalanceReducer from "../reducers/auth_tenant/retrieve_tenant_stock_take_starting_balance_Slice";
import tenantCreateStockTakeReducer from "../reducers/auth_tenant/tenant_create_stock_take_Slice";
import retrieveTenantStockTakeDetailsReducer from "../reducers/auth_tenant/retrieve_tenant_stock_take_details_Slice";
import retrieveTenantStockTakePreviewDetailsReducer from "../reducers/auth_tenant/retrieve_tenant_stock_take_preview_details_Slice";
import tenantSubmitStockTakeReportReducer from "../reducers/auth_tenant/tenant_submit_stock_take_report_Slice";
import tenantUpdateTheoreticalStockToPhysicalStockBalanceReducer from "../reducers/auth_tenant/tenant_update_theoretical_stock_to_physical_stock_balance_Slice";
import tenantUpdateStockTakeProductsReducer from "../reducers/auth_tenant/tenant_update_stock_take_products_Slice";

// Products
import tenantUpdateProductDetailsReducer from "../reducers/auth_tenant/tenant_update_product_details_Slice";

// Auth 
import signInAuthReducer from "../reducers/auth_tenant/sign_in_auth_Slice";
import verifyResignInOtpReducer from "../reducers/auth_tenant/verify_resign_in_otp_Slice";

// Warehouse Inventory
import retrieveTenantSpecificProductColorSizeDetailsReducer from "../reducers/auth_tenant/retrieve_tenant_specific_product_color_size_details_Slice";
import retrieveWarehouseInventoryAnalyticsReducer from "../reducers/auth_tenant/retrieve_warehouse_inventory_analytics_Slice";
import retrieveTenantStockAgeAnalysisSummaryReducer from "../reducers/auth_tenant/retrieve_tenant_stock_age_analysis_summary_Slice";
import retrieveTenantStockAgeAnalysisBrandAnalysisDataReducer from "../reducers/auth_tenant/retrieve_tenant_stock_age_analysis_brand_analysis_data_Slice";
import tenantRetrieveBrandStockAgeCategoryDataReducer from "../reducers/auth_tenant/tenant_retrieve_brand_stock_age_category_data_Slice";
import tenantRetrieveProductStockAgeAnalysisBreakdownReducer from "../reducers/auth_tenant/tenant_retrieve_product_stock_age_analysis_breakdown_Slice";
import retrieveTenantGoodsIssuedListReducer from "../reducers/auth_tenant/retrieve_tenant_goods_issued_list_slice";


// Products
import retrieveTenantProductAnalyticsReducer from "../reducers/auth_tenant/retrieve_tenant_product_analytics_Slice";
import updateTenantProductPriceReducer from "../reducers/auth_tenant/update_tenant_product_price_Slice";
import deleteOrderItemReducer from "../reducers/auth_tenant/delete_order_item_Slice";
import updateProductViewableOnWebstoreReducer from "../reducers/auth_tenant/update_product_viewable_on_webstore_Slice";
import tenantCancelOrderItemReducer from "../reducers/auth_tenant/tenant_cancel_order_item_Slice";



// Orders
import retrieveTenantOrderAnalyticsReducer from "../reducers/auth_tenant/retrieve_tenant_order_analytics_Slice";
import tenantEditOrderUnitsReducer from "../reducers/auth_tenant/tenant_edit_order_units_Slice";


// Settings
import retireveTenantOrderApproversAndSalesRepsReducer from "../reducers/auth_tenant/retrieve_tenant_order_approvers_and_sales_reps_Slice";
import tenantUpdateorderApproversReducer from "../reducers/auth_tenant/tenant_update_order_approvers_Slice";
import retrieveReadyForDispatchSettingReducer from "../reducers/auth_tenant/retrieve_ready_for_dispatch_settings_Slice";
import updateReadyForDispatchSettingsReducer from "../reducers/auth_tenant/update_ready_for_dispatch_settings_Slice";
import deleteEmployeeFromRadyForDispatchSettingsReducer from "../reducers/auth_tenant/delete_employee_from_ready_for_disaptch_Settings_Slice";
import retrieveBrandSettingsReducer from "../reducers/auth_tenant/retrieve_brands_settings_Slice";
import updateTenantBrandSettingsReducer from "../reducers/auth_tenant/update_tenant_brand_settings_Slice";
import deleteTenantBrandReducer from "../reducers/auth_tenant/delete_tenant_brand_Slice";
import retrieveStockMovementSuspensionSettingsReducer from "../reducers/auth_tenant/retrieve_stock_movement_suspension_settings_Slice";
import updateStockMovementSuspensionSettingsReducer from "../reducers/auth_tenant/update_stock_movement_suspension_settings_Slice";
import retrieveUssdSettingsReducer from "../reducers/auth_tenant/retrieve_ussd_settings_Slice";
import createUssdCodeReducer from "../reducers/auth_tenant/create_ussd_code_Slice";
import retriveTenantSMSPortalSettingsReducer from "../reducers/auth_tenant/retrieve_tenant_sms_portal_settings_Slice";
import editUssdCodeReducer from "../reducers/auth_tenant/edit_ussd_code_Slice";

// Agencies
import retriveTenantAgenciesReducer from "../reducers/auth_tenant/retrieve_tenant_agencies_Slice";
import addTenantAgencyRedcuer from "../reducers/auth_tenant/add_tenant_agency_Slice";
import retrieveTenantAgencyDetailsReducer from "../reducers/auth_tenant/retrieve_tenant_agency_details_Slice";
import retrieveTenantAgencyMainSalesRepDetailsReducer from "../reducers/auth_tenant/retrieve_tenant_agency_main_sales_rep_details_Slice";
import tenantUpdateAgencyMainSalesRepReducer from "../reducers/auth_tenant/tenant_update_agency_main_sales_rep_Slice";
import retrieveTenantAgencySalesRepDetailsReducer from "../reducers/auth_tenant/retrieve_tenant_agency_sales_rep_details_Slice";
import retrieveTenantAgencySalesRepApprovalSettingsReducer from "../reducers/auth_tenant/retrieve_tenant_agency_sales_rep_approval_settings_Slice";



// Agency Sales Rep
import tenantAddSalesRepToAgencyRedcuer from "../reducers/auth_tenant/tenant_add_sales_rep_to_agency_Slice";

// BUdeget Allocation 
import retrieveTenantBudgetAllocationsReducer from "../reducers/auth_tenant/retrieve_tenant_budget_allocations_Slice";
import retrieveAddBudgetAllocationDataReducer from "../reducers/auth_tenant/retrieve_add_budget_allocation_data_Slice";
import adddTenantBudgetAllocationReducer from "../reducers/auth_tenant/add_tenant_budget_allocation_Slice";
import retrieveBudgetAllocationMainDetailsReducer from "../reducers/auth_tenant/retrieve_budget_allocation_main_details_Slice";
import retrieveSpecificTenantSalesRepBudgetAllocationDetailsReducer from "../reducers/auth_tenant/retrieve_specific_tenant_sales_rep_budget_allocation_details_Slice";
import updateBudgetAllocationReducer from "../reducers/auth_tenant/update_budget_allocation_Slice";

// Retrieve Stock Levels
import retrieveStockLevelsReducer from "../reducers/auth_tenant/retrieve_stock_levels_Slice";

// Sales Reps
import retrieveSalesRepsDetailsReducer from "../reducers/auth_tenant/retrieve_sales_reps_details_Slice";
import tenantToggleSalesRepBrandReducer from "../reducers/auth_tenant/tenant_toggle_sales_rep_brand_Slice";
import retrieveSalesRepAllowedBrandDetailsReducer from "../reducers/auth_tenant/retrieve_sales_rep_allowed_brand_details_Slice";
import tenantToggleSalesRepBrandProductTypeReducer from "../reducers/auth_tenant/tenant_toggle_sales_rep_brand_product_type_Slice";


// Socket
import announcementsUpdateReducer from "../reducers/auth_tenant/announcements_update_Slice";

// Tenants
import retriveTenantModulesReducer from "../reducers/auth_tenant/retrieve_tenant_modules_Slice";
import retrieveAddTenantToModuleDataReducer from "../reducers/auth_tenant/retrieve_add_tenant_to_module_data_Slice";
import addModuleToTenantReducer from "../reducers/auth_tenant/add_module_to_tenant_Slice";
import retrieveEmployeesNotInTenantModuleDataReducer from "../reducers/auth_tenant/retrieve_employees_not_in_tenant_module_data_Slice";
import addEmployeeToTenantModuleReducer from "../reducers/auth_tenant/add_employee_to_tenant_module_Slice";

// Other
import retrieveModuleInformationReducer from "../reducers/auth_tenant/retrieve_module_information_Slice";

// Promotions
import retrievePromotionsListReducer from "../reducers/auth_tenant/retrieve_promotions_list_Slice";
import retrieveCreatePromotionDataReducer from "../reducers/auth_tenant/retrieve_create_promotion_data_Slice";
import createPromotionReducer from "../reducers/auth_tenant/create_promotion_Slice";
import retrievePromotionDetailsReducer from "../reducers/auth_tenant/retrieve_promotion_details_Slice";
import retrieveCreatePromotionDrawDataReducer from "../reducers/auth_tenant/retrieve_create_promotion_draw_data_Slice";
import createPromotionDrawReducer from "../reducers/auth_tenant/create_promotion_draw_Slice";
import retrievePromotionDrawDetailsReducer from "../reducers/auth_tenant/retrieve_promotion_draw_details_Slice";
import retrieveDrawParticipantsReducer from "../reducers/auth_tenant/retrieve_draw_participants_Slice";
import retrieveTenantParticipantsReducer from "../reducers/auth_tenant/retrieve_tenant_participants_Slice";
import retrieveContinuePromotionDrawDataReducer from "../reducers/auth_tenant/retrieve_continue_promotion_draw_data_Slice";
import tenantSelectDrawWinnerReducer from "../reducers/auth_tenant/tenent_select_draw_winner_Slice";
import retrieveTenantPromotionsCodeLookUpIntegrationSettingsReducer from "../reducers/auth_tenant/retrieve_tenant_promotions_code_lookup_integration_settings_Slice";
import updatePromotionCodeLookupIntegrationSettingsReducer from "../reducers/auth_tenant/update_promotion_code_lookup_integration_settings_Slice";
import retrieveTenantPromotionsMenuIdentifierSettingsReducer
 from "../reducers/auth_tenant/retrieve_tenant_promotions_menu_identifier_settings_Slice";
import renantUpdatePromotionsMenuIdentifierSettingsRedcuer from "../reducers/auth_tenant/tenant_update_promotions_menu_identifier_settings_Slice";
import retrieveTenantPromotionsRestrictedNumbersSettingsReducer from "../reducers/auth_tenant/retrieve_tenant_promotions_restricted_numbers_settings_Slice";
import tenantAddRestrictedNumberSettingsReducer from "../reducers/auth_tenant/tenant_add_restricted_number_settings_Slice";
import tenantDeleteRestrictedNumberSettingsReducer from "../reducers/auth_tenant/tenant_delete_restricted_number_settings_Slice";
import retrieveTenantPromotionsMessageSettingsReducer from "../reducers/auth_tenant/retrieve_tenant_promotions_message_settings_Slice";
import updatePromotionMessageSettingReducer from "../reducers/auth_tenant/update_promotion_message_setting_Slice";
import tenantDeletePromotionMessageSettingReducer from "../reducers/auth_tenant/tenant_delete_promotion_message_setting_Slice";


// Store For All Reducers
export const auth_tenants_store = configureStore({
 reducer: {
  retrieve_tenant_information: retriveTenantInformationreducer,
  retrieve_tenant_user_information: retrieveTenantUserInformationReducer,
  retrieve_tenants_list: retrieveTenantsListReducer,
  admin_create_tenant: adminCreateTenantReducer,
  retrieve_product_types: retrieveProductTypesReducer,
  add_product_type: addProductTypeReducer,
  retrieve_products: retrieveProductsReducer,
  retrieve_product_types_by_status: retrieveProductsTypesByStatusReducer,
  add_product: addProducteReducer,
  retrieve_warehouse_sites: retrieveWarehouseSitesReducer,
  add_warehouse_site: addWarehouseSiteReducer,
  retrieve_tenant_audit_trails: retrieveTenantAuditTrailsReducer,
  retrieve_tenant_profiles_list: retrieveTenantProfilesListReducer,
  retrieve_specific_tenant_settings: retrieveSpecificTenantSettingsReducer,
  update_tenant_logo: updateTenantLogoReducer,
  retrieve_profile_details: retrieveProfileDetailsReducer,
  retrieve_tenant_profile_roles: retrieveTenantProfileRolesReducer,
  update_tenant_profile_role: updateTenantProfileRoleReducer,
  retrieve_specific_tenant_product_details: retrieveSpecificTenantProductDetailsReducer,
  retreive_add_stock_details: retrieveAddStockDetailsReducer,
  auth_sign_out: authSignOutReducer,
  add_product_stock: addProductStockReducer,
  retrieve_tenant_sales_reps: retreiveTenantSalesRepsReducer,
  retrieve_brands_list: retrieveBrandsListReducer,
  add_tenant_sales_rep: addTenantSalesRepReducer,
  retrieve_sales_rep_tenant_pending_submissions_cart: retrieveSalesRepTenantPendingSubmissionsCartReducer,
  sales_rep_tenant_create_order: salesRepTenanrCreateOrderReducer,
  update_tenant_email_credentials: updateTenantEmailCredentialsReducer,
  add_employee_to_tenant: addEmployeeToTenantReducer,
  retrieve_tenant_orders_list: retrieveTenantOrdersListReducer,
  update_tenant_sms_credentials: updateTenantSmsCredentialsReducer,
  retrieve_sales_rep_tenant_order_list: retrieveSalesRepTenantOrderListReducer,
  retrieve_specific_sales_rep_tenant_order_details: retrieveSepecificSalesRepTenantOrderDetailsReducer,
  update_tenant_order_status: updateTenantOrderStatusReducer,
  add_product_to_existing_order: addProductToExistingOrderReducer,
  create_tenant_order_dispatch: createTenantOrderDispatchReducer,
  retrieve_tenant_dispatch_details: retrieveTenantDispatchDetailsReducer,
  add_products_to_dispatch_and_complete_dispatch: addProductsToDispatchAndCompleteDispatchReducer,
  sales_rep_confirm_dispatch_delivery: salesRepConfirmDispatchDeliveryReducer,
  retrieve_tenants_goods_received_list: retrieveTenantGoodsReceivedListRefucer,
  add_tenant_goods_received: addTenantGoodsRecievedReducer,
  retrieve_goods_received_details: retrieveGoodsReceivedDetailsReducer,
  add_products_to_goods_received_and_complete_goods_received: addProductsToGoodsReceivedAndCompleteGoodsReceivedRedcuer,
  retrieve_tenant_dashboard_data: retrieveTenantDashboardDataReducer,
  tenant_back_date_order: tenantBackDateOrderReducer,
  tenant_add_backdated_order_products: tenantAddBackdatedOrderProductsReducer,

  // Stock Take
  retrieve_tenant_stock_take_list: retrieveTenantStockTakeListReducer,
  retrieve_tenant_stock_take_starting_balance: retrieveTenantStockTakeStartinBalanceReducer,
  tenant_create_stock_take: tenantCreateStockTakeReducer,
  retrieve_tenant_stock_take_details: retrieveTenantStockTakeDetailsReducer,
  retrieve_tenant_stock_take_preview_details: retrieveTenantStockTakePreviewDetailsReducer,
  tenant_submit_stock_take_report: tenantSubmitStockTakeReportReducer,
  tenant_update_theoretical_stock_to_physical_stock_balance: tenantUpdateTheoreticalStockToPhysicalStockBalanceReducer,
  tenant_update_stock_take_products: tenantUpdateStockTakeProductsReducer,

  // Products
  update_tenant_product_image: updateTenantProductImageReducer,
  tenant_update_product_details: tenantUpdateProductDetailsReducer,

  // Auth 
  sign_in_auth: signInAuthReducer,
  verify_resign_in_otp: verifyResignInOtpReducer,

  // Warehouse Inventory
  retrieve_tenant_specific_product_color_size_details: retrieveTenantSpecificProductColorSizeDetailsReducer,
  retrieve_warehouse_inventory_analytics: retrieveWarehouseInventoryAnalyticsReducer,
  retrieve_tenant_stock_age_analysis_summary: retrieveTenantStockAgeAnalysisSummaryReducer,
  retrieve_tenant_stock_age_analysis_brand_analysis_data: retrieveTenantStockAgeAnalysisBrandAnalysisDataReducer,
  tenant_retrieve_brand_stock_age_category_data: tenantRetrieveBrandStockAgeCategoryDataReducer,
  tenant_retrieve_product_stock_age_analysis_breakdown: tenantRetrieveProductStockAgeAnalysisBreakdownReducer,
  retrieve_tenant_goods_issued_list: retrieveTenantGoodsIssuedListReducer,

  // Products
  retrieve_tenant_product_analytics: retrieveTenantProductAnalyticsReducer,
  update_tenant_product_price: updateTenantProductPriceReducer,
  update_product_viewable_on_webstore: updateProductViewableOnWebstoreReducer,

  // Orders
  retrieve_tenant_order_analytics: retrieveTenantOrderAnalyticsReducer,
  tenant_edit_order_units: tenantEditOrderUnitsReducer,
  delete_order_item: deleteOrderItemReducer,
  tenant_cancel_order_item: tenantCancelOrderItemReducer,

  // Settings
  retrieve_tenant_order_approvers_and_sales_reps: retireveTenantOrderApproversAndSalesRepsReducer,
  tenant_update_order_approvers: tenantUpdateorderApproversReducer,
  retrieve_ready_for_dispatch_settings: retrieveReadyForDispatchSettingReducer,
  update_ready_for_dispatch_settings: updateReadyForDispatchSettingsReducer,
  delete_employee_from_ready_for_disaptch_Settings: deleteEmployeeFromRadyForDispatchSettingsReducer,
  retrieve_brands_settings: retrieveBrandSettingsReducer,
  update_tenant_brand_settings: updateTenantBrandSettingsReducer,
  delete_tenant_brand: deleteTenantBrandReducer,
  retrieve_stock_movement_suspension_settings: retrieveStockMovementSuspensionSettingsReducer,
  update_stock_movement_suspension_settings: updateStockMovementSuspensionSettingsReducer,
  retrieve_ussd_settings: retrieveUssdSettingsReducer,
  create_ussd_code: createUssdCodeReducer,
  retrieve_tenant_sms_portal_settings: retriveTenantSMSPortalSettingsReducer,
  edit_ussd_code: editUssdCodeReducer,

  // Agencies
  retrieve_tenant_agencies: retriveTenantAgenciesReducer,
  add_tenant_agency: addTenantAgencyRedcuer,
  retrieve_tenant_agency_details: retrieveTenantAgencyDetailsReducer,
  retrieve_tenant_agency_main_sales_rep_details: retrieveTenantAgencyMainSalesRepDetailsReducer,
  tenant_update_agency_main_sales_rep: tenantUpdateAgencyMainSalesRepReducer,
  retrieve_tenant_agency_sales_rep_details: retrieveTenantAgencySalesRepDetailsReducer,
  retrieve_tenant_agency_sales_rep_approval_settings: retrieveTenantAgencySalesRepApprovalSettingsReducer,

  // Agency Sales Rep
  tenant_add_sales_rep_to_agency: tenantAddSalesRepToAgencyRedcuer,

  // Budget Allocations
  retrieve_tenant_budget_allocations: retrieveTenantBudgetAllocationsReducer,
  retrieve_add_budget_allocation_data: retrieveAddBudgetAllocationDataReducer,
  add_tenant_budget_allocation: adddTenantBudgetAllocationReducer,
  retrieve_budget_allocation_main_details: retrieveBudgetAllocationMainDetailsReducer,
  retrieve_specific_tenant_sales_rep_budget_allocation_details: retrieveSpecificTenantSalesRepBudgetAllocationDetailsReducer,
  update_budget_allocation: updateBudgetAllocationReducer,

  // Stock Levels
  retrieve_stock_levels: retrieveStockLevelsReducer,

  // Sales Reps
  retrieve_sales_reps_details: retrieveSalesRepsDetailsReducer,
  tenant_toggle_sales_rep_brand: tenantToggleSalesRepBrandReducer,
  retrieve_sales_rep_allowed_brand_details: retrieveSalesRepAllowedBrandDetailsReducer,
  tenant_toggle_sales_rep_brand_product_type: tenantToggleSalesRepBrandProductTypeReducer,

  // Socket
  announcements_update: announcementsUpdateReducer,

  // Tenants
  retrieve_tenant_modules: retriveTenantModulesReducer,
  retrieve_add_tenant_to_module_data: retrieveAddTenantToModuleDataReducer,
  add_module_to_tenant: addModuleToTenantReducer,
  retrieve_employees_not_in_tenant_module_data: retrieveEmployeesNotInTenantModuleDataReducer,
  add_employee_to_tenant_module: addEmployeeToTenantModuleReducer,

  // Other 
  retrieve_module_information: retrieveModuleInformationReducer,

  // Promotions
  retrieve_promotions_list: retrievePromotionsListReducer,
  retrieve_create_promotion_data: retrieveCreatePromotionDataReducer,
  create_promotion: createPromotionReducer,
  retrieve_promotion_details: retrievePromotionDetailsReducer,
  retrieve_create_promotion_draw_data: retrieveCreatePromotionDrawDataReducer,
  create_promotion_draw: createPromotionDrawReducer,
  retrieve_promotion_draw_details: retrievePromotionDrawDetailsReducer,
  retrieve_draw_participants: retrieveDrawParticipantsReducer,
  retrieve_tenant_participants: retrieveTenantParticipantsReducer,
  retrieve_continue_promotion_draw_data: retrieveContinuePromotionDrawDataReducer,
  tenent_select_draw_winner: tenantSelectDrawWinnerReducer,
  retrieve_tenant_promotions_code_lookup_integration_settings: retrieveTenantPromotionsCodeLookUpIntegrationSettingsReducer,
  update_promotion_code_lookup_integration_settings: updatePromotionCodeLookupIntegrationSettingsReducer,
  retrieve_tenant_promotions_menu_identifier_settings: retrieveTenantPromotionsMenuIdentifierSettingsReducer,
  tenant_update_promotions_menu_identifier_settings: renantUpdatePromotionsMenuIdentifierSettingsRedcuer,
  retrieve_tenant_promotions_restricted_numbers_settings: retrieveTenantPromotionsRestrictedNumbersSettingsReducer,
  tenant_add_restricted_number_settings: tenantAddRestrictedNumberSettingsReducer,
  tenant_delete_restricted_number_settings: tenantDeleteRestrictedNumberSettingsReducer,
  retrieve_tenant_promotions_message_settings: retrieveTenantPromotionsMessageSettingsReducer,
  update_promotion_message_setting: updatePromotionMessageSettingReducer,
  tenant_delete_promotion_message_setting: tenantDeletePromotionMessageSettingReducer,
 }
});